export const OAUTH_TOKEN_GET_REQUEST = 'app/oauth/OAUTH_TOKEN_GET_REQUEST';
export const OAUTH_TOKEN_GET_SUCCESS = 'app/oauth/OAUTH_TOKEN_GET_SUCCESS';
export const OAUTH_TOKEN_GET_FAILURE = 'app/oauth/OAUTH_TOKEN_GET_FAILURE';

export const OAUTH_STATE_CLEAR = 'app/oauth/OAUTH_STATE_CLEAR';
